import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { manhuaList, categories } from '@/mocks/manhua';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const manhuaInCategory = manhuaList.filter((m) => m.categorySlug === slug);

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'http://youplz.com/' },
      { '@type': 'ListItem', position: 2, name: category?.name || '分类', item: `http://youplz.com/category/${slug}` },
    ],
  };

  if (!category) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen flex items-center justify-center pt-16">
          <p className="text-foreground-500">分类不存在</p>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <Navbar />
      <main>
        <section className="bg-foreground-950 pt-24 pb-14 md:pb-20">
          <div className="px-4 md:px-8 lg:px-16">
            <nav className="flex items-center gap-2 text-xs text-foreground-400 mb-8" aria-label="面包屑导航">
              <Link to="/" className="hover:text-background-50 transition-colors whitespace-nowrap">首页</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-background-50 whitespace-nowrap">{category.name}</span>
            </nav>
            <div className="flex items-center gap-6 mb-10">
              <span className="inline-block px-4 py-1.5 border border-background-50/30 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                {category.name}分类
              </span>
              <h1 className="text-2xl md:text-4xl font-bold text-background-50 font-heading">
                {category.name}韩漫精选
              </h1>
            </div>
            <p className="text-sm text-foreground-400 mb-10 max-w-lg">{category.description}</p>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
              {manhuaInCategory.length > 0 ? (
                manhuaInCategory.map((manhua) => (
                  <Link
                    key={manhua.id}
                    to={`/manhua/${manhua.id}`}
                    className="group"
                  >
                    <div className="aspect-[3/4] rounded-lg overflow-hidden bg-background-100">
                      <img
                        src={manhua.cover}
                        alt={manhua.altText}
                        title={manhua.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                        loading="lazy"
                      />
                    </div>
                    <div className="mt-3">
                      <h3 className="text-sm font-medium text-background-50 truncate">{manhua.title}</h3>
                      <p className="text-xs text-foreground-400 mt-1 whitespace-nowrap">{manhua.latestChapter}</p>
                    </div>
                  </Link>
                ))
              ) : (
                <p className="text-foreground-400 col-span-full text-center py-10">该分类暂无作品</p>
              )}
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-14 md:py-20">
          <div className="px-4 md:px-8 lg:px-16">
            <div className="text-center mb-10">
              <div className="flex items-center justify-center gap-2 mb-4">
                <span className="w-2 h-2 rounded-full bg-primary-500 inline-block"></span>
                <span className="text-xs font-medium text-primary-600 whitespace-nowrap">相关推荐</span>
              </div>
              <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading">
                你可能也喜欢
              </h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {manhuaList
                .filter((m) => m.categorySlug !== slug)
                .slice(0, 8)
                .map((manhua) => (
                  <Link
                    key={manhua.id}
                    to={`/manhua/${manhua.id}`}
                    className="bg-background-50 rounded-lg p-4 hover:bg-primary-50/50 transition-colors group flex gap-4"
                  >
                    <div className="w-16 h-22 flex-shrink-0 rounded-md overflow-hidden bg-background-200">
                      <img
                        src={manhua.cover}
                        alt={manhua.altText}
                        className="w-full h-full object-cover"
                        loading="lazy"
                      />
                    </div>
                    <div className="min-w-0">
                      <h4 className="text-sm font-semibold text-foreground-900 truncate">{manhua.title}</h4>
                      <span className="inline-block mt-1 px-2 py-0.5 bg-secondary-100 text-secondary-700 text-[10px] rounded-full whitespace-nowrap">
                        {manhua.category}
                      </span>
                      <p className="text-[10px] text-foreground-400 mt-2 whitespace-nowrap">{manhua.latestChapter}</p>
                    </div>
                  </Link>
                ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}